import React from "react";
import { Typography } from 'antd';

const { Title } = Typography;

export const RenderHeader: React.FC<any> = ({level, children}) => {
    return <Title level={level as 1|2|3|4}>{children}</Title>
}